/**
 * Escapes user-controlled text so it is safe to embed inside an
 * innerHTML-bound dialog message string alongside trusted HTML markup.
 *
 * Uses pure string replacement — no DOM involved, fully synchronous,
 * and safe in SSR contexts.
 *
 * @example
 * // Safe: user-supplied name cannot inject HTML elements
 * message: `Wil je <strong>${escapeHtml(user.displayName)}</strong> verwijderen?`
 */
export function escapeHtml(text: string): string {
  return (text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
